"use client";

import { useState } from "react";
import { signIn } from "next-auth/react";
import { ArrowRight, Loader2, Mail } from "lucide-react";
import Link from "next/link";

export default function LoginPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // O NextAuth fará a chamada para o nosso auth.ts e enviará o e-mail
    await signIn("email", {
      email,
      callbackUrl: "/dashboard", // Redireciona para cá após clicar no e-mail
      redirect: true,
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md flex flex-col items-center">
        {/* Logo B+ */}
        <div className="w-16 h-16 mb-4">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className="w-full h-full shadow-sm rounded-2xl">
            <rect width="100" height="100" rx="24" fill="#2563eb" />
            <text x="42" y="54" fontFamily="system-ui, -apple-system, sans-serif" fontSize="56" fontWeight="bold" fill="#ffffff" textAnchor="middle" dominantBaseline="central">B</text>
            <text x="76" y="42" fontFamily="system-ui, -apple-system, sans-serif" fontSize="40" fontWeight="bold" fill="#60a5fa" textAnchor="middle" dominantBaseline="central">+</text>
          </svg>
        </div>
        <h2 className="text-center text-3xl font-extrabold text-gray-900">
          Acesse o Blugue Hub
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Nenhuma senha necessária. Acesse pelo seu e-mail.
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow-sm border border-gray-100 sm:rounded-2xl sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Endereço de E-mail
              </label>
              <div className="mt-1 relative rounded-md shadow-sm">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Mail className="h-5 w-5 text-gray-400" />
                </div>
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="focus:ring-blue-500 focus:border-blue-500 text-gray-900 block w-full pl-10 sm:text-sm border-gray-300 rounded-xl py-3 border bg-gray-50 outline-none transition-colors"
                  placeholder="voce@empresa.com"
                />
              </div>
            </div>

            <div>
              <button
                type="submit"
                disabled={loading}
                className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-xl shadow-sm text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {loading ? (
                  <>
                    <Loader2 className="w-5 h-5 mr-2 animate-spin" />
                    Enviando link mágico...
                  </>
                ) : (
                  <>
                    Continuar <ArrowRight className="w-5 h-5 ml-2" />
                  </>
                )}
              </button>
            </div>
          </form>
          
          <div className="mt-6 text-center">
            <Link href="/" className="text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors">
              ← Voltar para a página inicial
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}